import { Button } from "components/commons";
import PurchaseOrderInformationForm from "./purchase-order-information";
import styles from "./purchase-order.module.scss";
import PurchaseOrderProducts from "./products/products";
import locale from "localization";
import { useFormContext } from "contexts/form-context";

const PurchaseOrderForm = ({ loading, purchaseOrder, formMode, shiftsRecord }) => {
  const { isFormSubmittable, fields: rootFields } = useFormContext();

  return (
    <>
      <div className={styles.form}>
        <PurchaseOrderInformationForm purchaseOrder={purchaseOrder} formMode={formMode} />
      </div>
      <br />
      <br />
      {rootFields?.productType?.value && (
        <PurchaseOrderProducts shiftsRecord={shiftsRecord} formMode={formMode} />
      )}
      <br />
      <br />
      <Button type="submit" primary disabled={!isFormSubmittable || loading} loading={loading}>
        {locale.placeOrder}
      </Button>
    </>
  );
};

export default PurchaseOrderForm;
